
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homemade-food-delivery/[...cityPage]",
      function () {
        return require("private-next-pages/homemade-food-delivery/[...cityPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homemade-food-delivery/[...cityPage]"])
      });
    }
  